// extracted by mini-css-extract-plugin
export default {"forecast_area":"ForecastWeather_forecast_area__wlN3C","forecast_area__days_list":"ForecastWeather_forecast_area__days_list__WA4XF"};